import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';

export interface LoaderState {
  show: boolean;
}

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})

export class LoaderComponent implements OnInit {
  isLoading: Subject<boolean> = this.loaderService.isLoading;

  show = false;
  // private subscription: Subscription;

  constructor(private loaderService: LoaderService) { }

  ngOnInit() {
    alert('LoaderComponent')
    //const that = this;
    // this.subscription = this.loaderService.loaderState.subscribe(
    //   async (state: LoaderState) => {
    //     that.show = await state.show;
    //   }
    // );
  }

  ngOnDestroy() {
    //this.subscription.unsubscribe();
  }

}
